// extracted by mini-css-extract-plugin
export var colorSquare = "_m6-0";
export var danger = "_m6-5";
export var lightPink = "_m6-8";
export var neutralBlue = "_m6-7";
export var neutralYellow = "_m6-6";
export var normal = "_m6-1";
export var primary = "_m6-2";
export var primaryLight = "_m6-3";
export var solidBlack = "_m6-g";
export var solidGreen = "_m6-b";
export var solidLightBlue = "_m6-d";
export var solidNavy = "_m6-c";
export var solidOrange = "_m6-f";
export var solidPink = "_m6-e";
export var solidRed = "_m6-9";
export var solidYellow = "_m6-a";
export var success = "_m6-4";